/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApiKeyType } from './apiKeyType';


export interface InternalApiKeyViewModel { 
    key?: string | null;
    organizationId?: number;
    organizationName?: string | null;
    type?: ApiKeyType;
    description?: string | null;
    created?: string;
    lastUsed?: string | null;
    hashedKey?: string | null;
}

